module.exports = __webpack_public_path__ + "../resources/images/SkyCode_22-ba89e64290aa55be0989fe723efb7633.svg";